var exports = {
  "i": "xaee3c4fa--ea662e--wrapper",
};

module.exports = exports;
